import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconUserGuide = ({ sx, ...props }: SvgIconProps) => (
  <SvgIcon viewBox="0 0 20 20" {...props} sx={{ height: '24px', width: '24px', ...sx }}>
    <path
      d="M5.59961 14.4004L14.5996 5.40039M14.5996 5.40039H5.59961M14.5996 5.40039V14.4004"
      stroke="#202723"
      strokeWidth="1.4"
    />
  </SvgIcon>
);
